export enum RoleEnum {
  ROLE_PRS_KOMORNIK = 'ROLE_PRS-KOMORNIK',
  ROLE_PRS_OSOBAFIZYCZNA = 'ROLE_TOZ-DOMYSLNY', // 'ROLE_PRS-OSOBAFIZYCZNA'
  ROLE_PRS_OSOBAPRAWNA = 'ROLE_PRS-OSOBAPRAWNA',
  ROLE_PRS_SYNDYK = 'ROLE_PRS-SYNDYK',
  ROLE_PRS_KAS = 'ROLE_PRS-KASOWY',
  ROLE_PRS_SAD = 'ROLE_PRS-SADOWY',
  ROLE_PRS_ZUS = 'ROLE_PRS-ZUS',
  CCI_Kierownik = 'CI_KIEROWNIK',
  CCI_Pracownik = 'CI_PRACOWNIK',
  CCI_Pracownik_Legislacja = 'CI_PRACOWNIK_LEGISLACJA',
  CCI_Administrator = 'CI_ADMINISTRATOR',
  EKRS_Administrator = 'EKRS_ADMINISTRATOR'
}
